module.exports = __webpack_public_path__ + "static/desktop/img/words-left.fe4c1e6e.jpg";